import React, { Component } from "react";
import { connect } from "react-redux";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { IMAGE_PATH, BASE_IMAGES_URL, COMMON_FAIL_MESSAGE } from "Constants";
import { sortableHandle } from "react-sortable-hoc";
import { deleteImage } from "GalleryActions";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";

const DragHandle = sortableHandle(() => (
  <span className="drag-icon" style={{ cursor: "move" }}>
    <i className="fas fa-arrows-alt mx-6" aria-hidden="true"></i>
  </span>
));
class ImagesList extends Component {
  constructor(props) {
    super(props);
  }

  onDeleteLocationMap = () => {
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }
    confirmAlert({
      title: LocaleStrings.content_delete,
      message: LocaleStrings.content_gallery_dlt_message,
      confirmLabel: LocaleStrings.content_ok,
      cancelLabel: LocaleStrings.content_cancel,
      buttons: [
        {
          label: LocaleStrings.content_ok,
          onClick: () => {
            this.props.deleteImage(
              this.props.session,
              this.props.image.id,
              (result) => {
                if (result.success) {
                  this.props.showSuccess(
                    LocaleStrings.content_image_dlt_successfully
                  );
                  this.props.pagination(pageNo);
                  this.props.contentBoardStatus();
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.content_cancel,
          onClick: () => {},
        },
      ],
    });
  };
  _handleDownload(event, filepath) {
    if (
      filepath !== null &&
      filepath !== "null" &&
      filepath !== undefined &&
      filepath !== ""
    ) {
      window.open(filepath);
    }
  }

  render() {
    var { image, oldIndex, newIndex } = this.props;
    var key = image.id;
    var imageurl = "../../style/images/no-map-image.png";
    if (image.thumbpath !== "")
      imageurl = `${BASE_IMAGES_URL}/${image.thumbpath}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    var filename = `${BASE_IMAGES_URL}/${image.thumbpath}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}&download=true`;
    var mapStyle = {
      width: "200px",
      height: "200px",
      marginBottom: 25,
      marginRight: 15,
      position: "relative",
      display: "inline-block",
    };

    var itemStyle = {
      width: "100%",
      height: "inherit",
      objectFit: "cover",
      borderRadius: 5,
    };
    var style = {
      position: "absolute",
      top: "10px",
      right: "10px",
      cursor: "pointer",
    };
    var styledownload = {
      position: "absolute",
      top: "10px",
      right: "45px",
      cursor: "pointer",
    };

    var styleorder = {
      position: "absolute",
      bottom: "-15px",
      left: "10px",
      background: "rgb(0, 0, 0)",
      background: "rgba(0, 0, 0, 0.5)",
      color: "#f1f1f1",
      transition: ".5s ease",
      borderRadius: 5,
      width: 30,
      height: 30,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    var dragStyle = {
      position: "absolute",
      top: "10px",
      left: "10px",
      cursor: "move",
      background: "rgba(0, 0, 0, 0.5)",
      color: "#f1f1f1",
      transition: ".5s ease",
      borderRadius: 5,
      width: 30,
      height: 30,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    return (
      <div key={key} style={mapStyle}>
        <img src={imageurl} style={itemStyle} />
        <img
          src={IMAGE_PATH + "delete_map.png"}
          onClick={this.onDeleteLocationMap}
          style={style}
        />
        {/* {image.displayorder > 0 ? (
          <div style={styleorder}>{image.displayorder}</div>
        ) : (
          ""
        )} */}
        <div style={dragStyle}>
          <DragHandle />
        </div>
        <a href={filename} target="_blank" download>
          <img
            src={IMAGE_PATH + "download_gallery.png"}
            style={styledownload}
          />
        </a>

        {/* </div> */}
      </div>
    );
  }
}

var mapStateToProps = (state) => ({
  session: state.session,
});

export default connect(mapStateToProps, {
  deleteImage,
  showError,
  showSuccess,
})(ImagesList);
